import JudgmentFreeSupport from './JudgmentFreeSupport';

export default JudgmentFreeSupport;
